import React from 'react';

const CheckboxList = ({ selectedIds, setSelectedIds, data }) => {
  const handleCheckboxChange = (id) => {
    setSelectedIds((prevSelectedIds) =>
      prevSelectedIds.includes(id)
        ? prevSelectedIds.filter((selectedId) => selectedId !== id)
        : [...prevSelectedIds, id]
    );
  };

  return (
    <div className="fixed inset-0 p-4 overflow-y-auto grid grid-cols-1 md:grid-cols-1 gap-6 bg-gray-100">
      {data.map((item) => (
        <div
          key={item._id}
          className={`col-span-1 shadow-md rounded-lg p-6 mb-4 flex items-center ${
            item.isCopied ? 'bg-green-200' : 'bg-white'
          }`}
        >
          <label className="flex items-center space-x-4">
            <input
              type="checkbox"
              checked={selectedIds.includes(item._id)}
              onChange={() => handleCheckboxChange(item._id)}
              className="form-checkbox h-7 w-7 text-blue-600"
            />
            <span className="text-gray-900 text-lg">{item.brandName}</span>
          </label>
        </div>
      ))}
    </div>
  );
};

export default CheckboxList;
